

export const anonymousMenuItems = [


    {
        id: 1,
        label: 'Qui sommes-nous',
        icon: '',
        withIcon: true,
        subItems:[],
        link: '#presentation', 
        
    },

    {
        id: 2,
        label: 'Marques',
        link: '#brands',
        icon: '4',
     
    },
    
    {
        id: 3,
        label: 'Contactez-nous',
        link: '#contactus',
        icon: '4 ',
    },
    
    {
        id: 5,
        label: 'Partenaires',
        icon: '4',
        link: '#partners',
    },

    {
        id: 4,
        label: 'Espace Client',
        icon: '4',
        color: 'text-warning',
        link: '/login',
    },


 

];

